import { API } from ".";

export const GET_PLAN_REQUEST = "@@plan/GET_PLAN_REQUEST";
export const GET_PLAN_SUCCESS = "@@plan/GET_PLAN_SUCCESS";
export const GET_PLAN_FAILURE = "@@plan/GET_PLAN_FAILURE";

export function getPlan(id, start) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: GET_PLAN_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/site/${id}/plan?start=${start}`);
      dispatch({
        type: GET_PLAN_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_PLAN_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_PLAN = "@@plan/CLEAR_PLAN";

export function clearPlan() {
  return {
    type: CLEAR_PLAN,
  };
}